import { Table as CustomFieldValueTable } from '@/components/custom_field_value/table'
import { CustomFieldResource } from '@/types'
interface Props {
  id: string
}

export const EditCustomFields = ({ id }: Props) => {
  return (
    <CustomFieldValueTable
      filters={{
        resourceIdEq: id,
        resourceTypeEq: CustomFieldResource.Package
      }}
      createable
      fixedHeight
      updateable
    />
  )
}
